export default __webpack_public_path__ + "static/media/error-device-graphic.13fa0839.png";